import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tab, Tabs, Container } from 'react-bootstrap';
import '../../css/estudiantes.css';
import ConfigureAcademicAreas from './ConfigureAcademicAreas';
import DimensionAcademica from './DimensionAcademica';
import AcademicPeriod from './periodoAcademico';
import ConfigureGrades from './grados';
import ConfigureYears from './ConfigureYears';
import Courses from './CursosAdmin';
import Asignatura from './asignatura';
import AcademicOrganization from './organizacionAcademica';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChalkboardTeacher, faCalendarAlt, faBookOpen, faAtom, faShapes, faGraduationCap, faClock, faBook, faFileInvoiceDollar, faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import Horario from '../Asistencia/horario';

const ConfiguracionAcademica = () => {
    const [searchParams] = useSearchParams();
    // Permite enlazar directo a una pestaña puntual, ej. /ConfiguracionAcademica?tab=periodos
    // (usado por la Guía de Configuración para llevar al admin paso a paso).
    const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'organizacionAcademica');

    const handleSelect = (selectedTab) => {
        setActiveTab(selectedTab);
    };

    return (
        <div className="mt-4">
            <div className="card">
                
                <div className="card-body">
                    <Tabs activeKey={activeTab} onSelect={handleSelect} className="mb-3">
                        <Tab eventKey="añosEscolares" title={<span><FontAwesomeIcon icon={faCalendarAlt} /> Año Esc.</span>}>
                            <ConfigureYears />
                        </Tab>
                        <Tab eventKey="periodos" title={<span><FontAwesomeIcon icon={faClock} /> Períodos</span>}>
                            <AcademicPeriod />
                        </Tab>
                        <Tab eventKey="areasAcademicas" title={<span><FontAwesomeIcon icon={faAtom} /> Áreas</span>}>
                            <ConfigureAcademicAreas />
                        </Tab>
                        <Tab eventKey="dimensionAcademica" title={<span><FontAwesomeIcon icon={faShapes} /> Dimensiones</span>}>
                            <DimensionAcademica />
                        </Tab>
                        <Tab eventKey="asignaturas" title={<span><FontAwesomeIcon icon={faBook} /> Asignaturas</span>}>
                            <Asignatura />
                        </Tab>
                        <Tab eventKey="grados" title={<span><FontAwesomeIcon icon={faGraduationCap} /> Grados</span>}>
                            <ConfigureGrades />
                        </Tab>
                        <Tab eventKey="cursos" title={<span><FontAwesomeIcon icon={faBookOpen} /> Cursos</span>}>
                            <Courses />
                        </Tab>
                        <Tab eventKey="organizacionAcademica" title={<span><FontAwesomeIcon icon={faChalkboardTeacher} /> Org. Académica</span>}>
                            <AcademicOrganization />
                        </Tab>
                        <Tab eventKey="Horario" title={<span><FontAwesomeIcon icon={faCalendarDay} /> Horario</span>}>
                            <Horario />
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </div>
    );
};

export default ConfiguracionAcademica;
